import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCategories } from "../../../hooks/useProducts";
import loaderIcon from "../../../images/icons/loader.svg";
import LazyImage from "../../common/LazyImage";

const ProductsRange = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { data, isLoading, isError } = useCategories(); // получаем список категорий продуктов

  useEffect(() => {
    if (data) {
      // Устанавливаем pageTitle для breadcrumbs и title
      navigate(location.pathname, {
        replace: true,
        state: {
          ...location.state,
          pageTitle: "Продукты",
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, location.pathname, navigate]);

  if (isLoading) {
    return (
      <div className="loader">
        <img src={loaderIcon} alt="loader" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="page-width">
        Ошибка во время загрузки категорий продуктов
      </div>
    );
  }

  // Сортируем категории по полю sort
  const items = [...(data?.result || [])].sort(
    (a, b) => (a.sort ?? 0) - (b.sort ?? 0)
  );

  return (
    <div className="products-range page-width">
      <div className="pump-series-grid product-range-grid">
        {items.map((category) => (
          <Link
            key={category.id}
            to={`/products/${category.id}`}
            state={{ categoryName: category.name, pageTitle: category.name }}
            className="pump-series-card product-range-card"
          >
            <div className="range-image-container">
              {category.image && (
                <LazyImage
                  src={category.image}
                  alt={category.name}
                  className="series-image"
                />
              )}
            </div>
            <div className="series-info">
              <h3>{category.name}</h3>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ProductsRange;
